module.exports = __webpack_public_path__ + "static/media/copyIcon.46a5e5b1.png";